export const mmToInch = 0.0393701;

export const mbToBytes = 1024 * 1024;
export const bytesToMb = 1 / mbToBytes;

export const degreesToRadians = (angle: number | undefined) => {
    return angle ? angle * Math.PI / 180 : 0;
};